var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeepRl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "Deep RL agent for game environments",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dr-bg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b2e8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a1342"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 22,
    fill: "url(#dr-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fef3c7",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 14,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 88,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 86,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 46,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 62,
    r: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fbbf24",
    strokeWidth: 1,
    opacity: 0.55,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 14,
    x2: 42,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 14,
    x2: 58,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 9,
    x2: 42,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 9,
    x2: 58,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 14,
    x2: 42,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 14,
    x2: 58,
    y2: 22
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fbbf24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 9,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 14,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 22,
    r: 2.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 22,
    r: 2.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    opacity: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1.6,2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 25,
    x2: 44,
    y2: 33
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 25,
    x2: 56,
    y2: 33
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#2dd4bf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 65,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 65,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 71,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 71,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 71,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 71,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 77,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 77,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 77,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 77,
    width: 6,
    height: 6
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#f472b6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 53,
    width: 6,
    height: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepRl);
export default __webpack_public_path__ + "static/media/deep-rl.b7ffc336eb7bdde7477ba5c96453ac5a.svg";
export { ForwardRef as ReactComponent };